import type { RootState } from '@/root-store';

const getBills = (state: RootState) => state.bills.bills;

const getUpcomingBill = (state: RootState) => state.bills.upcomingBill;

export { getBills, getUpcomingBill };
